import React from "react";
import {typeAudienceService} from "../../jwt/_services/eventx/typeAudienceService";

export const typeAudienceProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        let dataRequest = {
            item: {}
        }
        const udn = localStorage.getItem('selectedUdn') === 'undefined' ? null : JSON.parse( localStorage.getItem('selectedUdn') );
        if (udn !== null){
            dataRequest.item.udn = udn?.id
        }

        const listItems = await typeAudienceService.search(0, 100, dataRequest);
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code + " - " + item.name,
                    label: <label>{ item.code?.toUpperCase() + ' - '  } <b>{ item.name }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error);
    }
}

async function getItem(id){
    try {
        const item = await typeAudienceService.getItem(id);
        return (
            {
                id: item.id,
                value: item.code + " - " + item.name,
                label: <div><label>{item.code + " - " + item.name}</label></div>
            }
        );
    } catch (error) {
        console.log(error);
    }
}